import { ImageComponent } from 'components/Image';
import { LocalizedLink } from 'components/LocalizedLink';
import { ConfigContext } from 'contexts/config';
import { useTheme } from 'hooks/theme';
import type { FC } from 'react';
import { useContext } from 'react';
import { ScLogo } from './styled';

interface LogoProps {
  height?: number;
  mobHeight?: number;
  smallLogo?: boolean;
  onClick?: () => void;
}

export const Logo: FC<LogoProps> = ({ smallLogo, onClick, ...props }) => {
  const { height } = props;
  const { menu } = useTheme();
  const { activeBrandAsset } = useContext(ConfigContext);

  const defaultLogo = smallLogo ? (
    <menu.logoSmall.component />
  ) : (
    <menu.logo.component />
  );

  const logoFromCms = smallLogo
    ? activeBrandAsset?.logoMobile?.url
    : activeBrandAsset?.logoDesktop?.url;

  const isSmallCmsLogo = smallLogo && !!logoFromCms;

  let cmsLogo = null;
  if (logoFromCms) {
    cmsLogo = activeBrandAsset?.animatedLogo ? (
      <object
        aria-label="Lucky Elf"
        className="cms-logo"
        data={logoFromCms}
        height={smallLogo || height ? '100%' : 34}
        width={smallLogo ? 48 : '100%'}
      />
    ) : (
      <ImageComponent
        alt="Lucky Elf"
        className="cms-logo"
        height={smallLogo || height ? '100%' : 34}
        src={logoFromCms}
        width={smallLogo ? 48 : '100%'}
      />
    );
  }

  return (
    <ScLogo {...props} height={isSmallCmsLogo ? (height ?? 48) : height}>
      <LocalizedLink className="logo" href="/" onClick={onClick}>
        {cmsLogo || defaultLogo}
      </LocalizedLink>
    </ScLogo>
  );
};
